export const meta: BlockMeta = {
  title: "Partners Texts",
  description: "A block made of a title and grid of partners texts",
  keywords: ["content"],
  cache: false,
  tags: ["root"],
  conditions: {
    postTypes: ["page", "post", "article", "hall-of-fame"],
  },
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, InnerBlocks } from "eddev/blocks"
import { tv } from "tailwind-variants"

export default defineBlock("content/partners-texts", (props) => {
  return (
    <div>
      <InnerBlocks
        template={[
          [
            "content/grid-rows",
            { data: { columns: "2", _columns: "field_6695bba1c5ee7" } },
            [
              [
                "acf/content-grid-rows-item",
                {},
                [["core/paragraph", { placeholder: "Partners Title", className: "is-style-title-medium" }]],
              ],
              [
                "acf/content-grid-rows-item",
                {},
                [["core/paragraph", { placeholder: "Partners Title", className: "is-style-title-medium" }]],
              ],
            ],
          ],
          ["content/divider", { data: { size: "medium", _size: "field_668f094e763c1" } }],
          [
            "content/grid-rows",
            { data: { columns: "2", _columns: "field_6695bba1c5ee7" } },
            [
              [
                "acf/content-grid-rows-item",
                {},
                [["core/paragraph", { placeholder: "Partner", className: "is-style-title-xsmall-bold" }]],
              ],
              [
                "acf/content-grid-rows-item",
                {},
                [["core/paragraph", { placeholder: "Partner", className: "is-style-title-xsmall-bold" }]],
              ],
            ],
          ],
          ["content/spacer", { data: { size: "8", _size: "field_668f0a4428db9" } }],
        ]}
        orientation="vertical"
      />
    </div>
  )
})
